// store/slices/organizationSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Organization } from '../../types';

interface OrganizationState {
  current: Organization | null;
  loading: boolean;
  error: string | null;
}

const initialState: OrganizationState = {
  current: null,
  loading: false,
  error: null,
};

const organizationSlice = createSlice({
  name: 'organization',
  initialState,
  reducers: {
    setCurrentOrganization: (state, action: PayloadAction<Organization>) => {
      state.current = action.payload;
    },
  },
});

export const { setCurrentOrganization } = organizationSlice.actions;
export default organizationSlice.reducer;